import { getAppConfig } from '../config/appConfig.js'

export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const base = getAppConfig().apiUrl
  // import.meta.env.DEV is Vite's built-in flag — true only under the local `vite`
  // dev server, false in any built artifact (including the deployed dev tier). It
  // is a build-time concern (dev server vs bundle), distinct from the deployment
  // tier, which lives in runtime config (see config/appConfig.ts).
  const isDev = import.meta.env.DEV

  // Under the local Vite dev server, route absolute external URLs through the
  // dev-server proxy so the browser treats them as same-origin — no CORS preflight,
  // and the proxy injects DEV_AUTH_TOKEN as a Cookie header server-side
  // (see vite.config.ts).
  //
  //   https://dev.ethisphere.com/api/v1/navigation
  //     → /ext/dev.ethisphere.com/api/v1/navigation   (proxy → dev.ethisphere.com)
  //
  // In any built/deployed artifact the app is served from the same domain, so absolute
  // URLs are used as-is — cookies are same-site and CORS is not an issue.
  let url: string
  if (/^https?:\/\//.test(path)) {
    if (isDev) {
      const { hostname, pathname, search } = new URL(path)
      url = `/ext/${hostname}${pathname}${search}`
    } else {
      url = path
    }
  } else {
    url = `${base}${path}`
  }

  // Strip credentials from caller init so env-driven behaviour always wins.
  const { headers: initHeaders, credentials: _ignored, ...restInit } = init ?? {}
  const headers: Record<string, string> = {
    'content-type': 'application/json',
    ...((initHeaders as Record<string, string>) ?? {}),
  }
  // credentials: 'include' tells the browser to attach cookies on every request.
  return fetch(url, { ...restInit, headers, credentials: 'include' })
}
